<template>
  <transition name="fade">
    <div v-if="visible" class="toast" :class="tipo">
      {{ mensaje }}
    </div>
  </transition>
</template>

<script setup lang="ts">
/**
 * Aviso efímero no bloqueante.
 *
 * Componente de presentación. Recibe sus datos por props o del store del módulo.
 */

import { ref } from 'vue'

const visible = ref(false)
const mensaje = ref('')
const tipo = ref<'exito' | 'error'>('exito')

function showToast(msg: string, t: 'exito' | 'error' = 'exito') {
  mensaje.value = msg
  tipo.value = t
  visible.value = true
  setTimeout(() => (visible.value = false), 3000)
}

defineExpose({ showToast })
</script>

<style scoped>
.toast {
  position: fixed;
  bottom: 24px;
  right: 24px;
  padding: 12px 20px;
  border-radius: var(--radius-md);
  color: white;
  font-weight: 600;
  font-family: var(--font-family);
  box-shadow: var(--shadow-lg);
  animation: slide-up 0.3s ease;
}

@keyframes slide-up {
  from { transform: translateY(10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}
.toast.exito { background: #28a745; }
.toast.error { background: #dc3545; }
.fade-enter-active, .fade-leave-active { transition: opacity .5s; }
.fade-enter-from, .fade-leave-to { opacity: 0; }
</style>
